// extracted by mini-css-extract-plugin
module.exports = {"notify__container":"notify_notify__container__2hyF3","notify__text":"notify_notify__text__9_Zl8"};